module.exports = __webpack_public_path__ + "static/media/aeromeghLog.f911a352.png";